(function(){
function initAccordion(){
  var hook = document.querySelector('.desc-hook');
  if(!hook) return;

  var sections = document.querySelectorAll('.desc-hook, .desc-details, .desc-specs');
  sections.forEach(function(sec){
    var isHook = sec.classList.contains('desc-hook');
    var label = '';
    if(isHook){
      label = 'Description';
    } else {
      var strongEl = sec.querySelector('p > strong');
      if(strongEl){
        label = strongEl.textContent.replace(':','');
        strongEl.parentElement.remove();
      } else { return; }
    }
    var header = document.createElement('div');
    header.className = 'desc-accordion-header';
    header.innerHTML = '<strong>' + label + '</strong><span class="desc-accordion-icon">' + (isHook ? '\u2212' : '+') + '</span>';
    var body = document.createElement('div');
    body.className = 'desc-accordion-body' + (isHook ? ' is-open' : '');
    while(sec.firstChild){ body.appendChild(sec.firstChild); }
    sec.appendChild(header);
    sec.appendChild(body);
    header.addEventListener('click', function(){
      var icon = header.querySelector('.desc-accordion-icon');
      if(body.classList.contains('is-open')){
        body.classList.remove('is-open');
        icon.textContent = '+';
      } else {
        body.classList.add('is-open');
        icon.textContent = '\u2212';
      }
    });
  });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', initAccordion);
} else {
  initAccordion();
}
})();

;(function(){
  var w = document.querySelector('.wysiwyg [style*="max-width"]');
  if(!w) return;
  var s = document.createElement('style');
  s.textContent = '.wysiwyg [style*="max-width"]{max-width:680px!important;margin:0 auto!important}.wysiwyg [style*="max-width"] p{font-size:15px!important;line-height:1.65!important;color:#333!important;margin:0 0 16px!important}.wysiwyg [style*="max-width"] h2{font-size:20px!important;font-weight:700!important;color:#000!important;margin:32px 0 12px!important;letter-spacing:0.5px!important;text-transform:none!important}.wysiwyg [style*="max-width"] ul{font-size:15px!important;line-height:1.65!important;color:#333!important;padding-left:24px!important;margin:0 0 20px!important}.wysiwyg [style*="max-width"] li{margin-bottom:8px!important;font-size:15px!important;color:#333!important}.wysiwyg [style*="max-width"] a{color:#000!important;text-decoration:underline!important}';
  document.head.appendChild(s);
})();